/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CrucigramaPalabrasForm from './CrucigramaPalabrasForm';
import * as validations from '../../validations/validations';
import * as crucigramapalabrasActions from '../../actions/crucigramapalabrasActions';

import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
 import $ from 'jquery';


class ManageCrucigramaPalabrasForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			crucigramapalabras:{
                    },
            posicionCombo:[
                {id:"across", descripcion:"Horizontal"},
                {id:"down", descripcion:"Vertical"}
            
            ],
            
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        let pageInfo={ 
            page:'crucigramapalabras', 
            idioma:this.props.idioma     
        }; 
       this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
     
    }
    
    
     componentWillReceiveProps(nextProps) {	
        
       if(nextProps.id!=this.props.id){
           this.cargar(nextProps.id);
       }
      
	}
    
    
    cargar=(id)=>{
        
        if(id && id>0 ){
            
            this.props.crucigramapalabrasActions.getCrucigramaPalabras(id, this.props.user).then( crucigramapalabras=>{
                    this.setState({"crucigramapalabras":crucigramapalabras});
                })
                .catch(error=>{
                  toastr.error(error);
                }); 
        }else{
            let crucigramapalabras = this.state.crucigramapalabras;
            this.setState({crucigramapalabras:[]});
            
            /*   
            pregunta.nombre=" ";
            pregunta.point=0;
            pregunta.explanation=" ";
            pregunta.messageForCorrect="";
            pregunta.messageForIncorrect=" ";
            pregunta.answerSelectionType=null;
            
            this.setState({pregunta:pregunta, respuestas:[]});
            */
        }
    
    }
    

    handleChange=(event, data)=> {

        let crucigramapalabras = this.state.crucigramapalabras;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		crucigramapalabras[field[0]]= value;
		else{
             if(!crucigramapalabras[field[0]]){
                    crucigramapalabras[field[0]]={}
                }
			crucigramapalabras[field[0]][field[1]]= value;
		}
        
		
        this.setState({"crucigramapalabras": crucigramapalabras});
    }
    
    
   
    
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let crucigramapalabras=this.state.crucigramapalabras;
              
       
        if(!validations.requerido(crucigramapalabras.clue)){
            errors.clue=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(crucigramapalabras.answer)){
            errors.answer=true;
            formIsValid=false;
        }
       
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        this.state.crucigramapalabras.crucigramaId = this.props.idForm;
        
        this.props.crucigramapalabrasActions.save(this.state.crucigramapalabras, this.props.user).then((palabraGuardada) => {
            toastr.success("Registro guardado!!!.");
            this.cargar(palabraGuardada.id);
            
            this.props.inicializa();
            
        });
        
        
        
    }

       
    render() {	
        
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <div>
                <CrucigramaPalabrasForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.crucigramapalabras}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    posicionCombo={genericFormattedForDropdown(this.state.posicionCombo)}
                    
                />

            </div> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    //let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        //id,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        crucigramapalabrasActions: bindActionCreators(crucigramapalabrasActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageCrucigramaPalabrasForm);